module.exports = __webpack_public_path__ + "static/media/home.74c45637.jpg";